var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15625 12.6562C5.41513 12.6562 5.625 12.4464 5.625 12.1875C5.625 11.9286 5.41513 11.7188 5.15625 11.7188C4.89737 11.7188 4.6875 11.9286 4.6875 12.1875C4.6875 12.4464 4.89737 12.6562 5.15625 12.6562Z",
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7188 12.6562C11.9776 12.6562 12.1875 12.4464 12.1875 12.1875C12.1875 11.9286 11.9776 11.7188 11.7188 11.7188C11.4599 11.7188 11.25 11.9286 11.25 12.1875C11.25 12.4464 11.4599 12.6562 11.7188 12.6562Z",
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40625 2.34375H3.28125L4.6875 10.3125H12.1875",
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 8.4375H11.9953C12.0495 8.43754 12.1021 8.41879 12.144 8.38444C12.1859 8.35009 12.2147 8.30227 12.2253 8.24912L13.069 4.03037C13.0759 3.99635 13.075 3.96125 13.0666 3.92759C13.0582 3.89393 13.0424 3.86256 13.0204 3.83573C12.9984 3.80891 12.9708 3.78731 12.9394 3.77248C12.908 3.75765 12.8738 3.74998 12.8391 3.75H3.75",
    stroke: "#F4F4F4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartoutline);
export default __webpack_public_path__ + "static/media/cartoutline.c68e5e7b2ffb57eaad031f1461e959d0.svg";
export { ForwardRef as ReactComponent };